<script setup lang="ts">
import { RouterLink } from 'hybridly/vue'

const { matches } = useRoute()
</script>

<template>
	<div class="mb-4 flex flex-wrap gap-4 border-b pb-4">
		<ui-button :as="RouterLink" :href="route('teams.show')" :variant="matches('teams.show') ? 'secondary' : 'ghost'">
			{{ t('app.buttons.settings') }}
		</ui-button>
		<ui-button
			:as="RouterLink"
			:href="route('team-members.show')"
			:variant="//@ts-ignore
				matches('team-members.*') ? 'secondary' : 'ghost'"
		>
			{{ t('app.buttons.members') }}
		</ui-button>
		<ui-button
			:as="RouterLink"
			:href="route('team-subscription.show')"
			:variant="//@ts-ignore
				matches('team-subscription.*') ? 'secondary' : 'ghost'"
		>
			{{ t('app.buttons.subscription') }}
		</ui-button>
		<ui-button
			:as="RouterLink"
			:href="route('team-usage.show')"
			:variant="//@ts-ignore
				matches('team-usage.*') ? 'secondary' : 'ghost'"
		>
			{{ t('app.buttons.usage') }}
		</ui-button>
	</div>
</template>
